export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5156.4baf385a.jpg";